<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeRegimeTva.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit"
               @click="checkPermissions(constantes.PARAMETRAGE_REGIME_TVA.maj)
          ? setRegimeTvaToUpdate(null) : showPopUp()"
               :class="{'button-access-no-permission' :
               !checkPermissions(constantes.PARAMETRAGE_REGIME_TVA.maj) }">
              {{ $t('listeRegimeTva.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column">
            <b-input :placeholder="$t('general.button.search')"
                     type="search" icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                  :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
    <v-server-table @loaded="finLoading" @loading="debutLoading"
                    :columns="columns" :options="options"
                    class="tableWithPerPageSelection"
                    ref="tableRegimeTva">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableRegimeTva.setLimit($event)"/>
      </template>
      <div slot="actif" slot-scope="props" class="has-text-centered">
        <b-checkbox class="pointer-events-none" v-model="props.row.actif" type="is-default">
        </b-checkbox>
      </div>
      <div slot="cleComptable" slot-scope="props">
        <b-tooltip :label="$t('listeRegimeTva.tab.cleComptableToolTip')">
          {{props.row.cleComptable}}
        </b-tooltip>
      </div>
      <div slot="tauxTva" slot-scope="props">
        {{ props.row.tauxTva | formatPercent}}
      </div>
      <div slot="edit" slot-scope="props">
        <div @click="checkPermissions(constantes.PARAMETRAGE_REGIME_TVA.supprimer) ?
        setRegimeTvaToUpdate(props.row) : showPopUp()" class="is-cursor-pointer">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.PARAMETRAGE_REGIME_TVA.maj) }"></b-icon>
        </div>
      </div>
      <div slot="archiver" slot-scope="props">
        <div @click="checkPermissions(constantes.PARAMETRAGE_REGIME_TVA.supprimer)
        ? setProduitToArchive(props.row) :
            showPopUp()" class="is-cursor-pointer">
          <b-icon type="is-default" :icon="props.row.actif ? 'archive' : 'archive-arrow-up'"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.PARAMETRAGE_REGIME_TVA.supprimer) }">
          </b-icon>
        </div>
      </div>
      <div slot="delete">
        <div @click="checkPermissions(constantes.PARAMETRAGE_REGIME_TVA.supprimer) ? inProgress() :
            showPopUp()"
             class="is-cursor-pointer">
          <b-icon type="is-danger" icon="delete-forever" :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.PARAMETRAGE_REGIME_TVA.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <b-modal v-model="popUpRegimeTva" has-modal-card class="modal">
      <pop-up-add-edit-regime-tva :oldRegimeTva="regimeTvaToEdit" @recherche="recherche()"/>
    </b-modal>
    <b-modal v-model="popUpArchivageRegimeTva" has-modal-card class="modal">
      <pop-up-archivage v-if="popUpArchivageRegimeTva"
        :messHeader="$t(regimeTvaToArchive.actif ?
      'listeRegimeTva.archivage.archiver': 'listeRegimeTva.archivage.desarchiver')"
                        :cancel="$t('listeRegimeTva.archivage.no')"
                        :validate="$t('listeRegimeTva.archivage.yes')"
                        :is-error-popup="error"
                        :messages-popup="messages"
                        @no="popUpArchivageRegimeTva = false"
                        @yes="archiverProduit()"/>
    </b-modal>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-regime-tva  @toggleFiltre="setShowFiltre"
                          ref="filtreRegimeTva"
                                 @recherche="makeRechercheFilter"/>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { PARAMETRAGE_REGIME_TVA } from '@/configuration/general/permissionsParametrageConf';
import inProgress from '@/services/general/inProgress';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import popUpAddEditRegimeTva from '@/components/parametrage/regimeTva/p_addEditRegimeTva';
import genererRegimeTva from '@/services/parametrage/generation/genererRegimeTva';
import filtreRegimeTva from '@/components/parametrage/regimeTva/filtreRegimeTva';
import { archiver } from '@/api/regimeTva';
import popUpArchivage from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { validationArchivage } from '@/services/parametrage/validation/validationRegimeTva';

const Permissions = createNamespacedHelpers('permissions');
const RegimeTva = createNamespacedHelpers('regimeTva');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      constantes: {
        PARAMETRAGE_REGIME_TVA,
      },
      unsubscribeValue: null,
      popUpRegimeTva: false,
      regimeTvaToEdit: null,
      showFiltre: false,
      regimeTvaToArchive: null,
      popUpArchivageRegimeTva: false,
      messages: [],
      error: false,
    };
  },
  components: {
    filtreRegimeTva,
    appBreadcrumb: breadcrumb,
    TableItemsInView,
    popUpArchivage,
    popUpAddEditRegimeTva,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...RegimeTva.mapGetters({
      regimesTva: 'items',
      totalCount: 'totalCount',
      criteresRecherche: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('general.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeRegimeTva.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
    nombreCritere() {
      let nombreCritere = 0;
      nombreCritere += this.criteresRecherche.actif !== null ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeRegimeTva.tab.libelle'),
          compteCentralisationClient: this.$t('listeRegimeTva.tab.compteCentralisationClient'),
          compteCentralisationFournisseur: this.$t('listeRegimeTva.tab.compteCentralisationFournisseur'),
          tauxTva: this.$t('listeRegimeTva.tab.tauxTva'),
          cleComptable: this.$t('listeRegimeTva.tab.cleComptable'),
          actif: this.$t('listeRegimeTva.tab.actif'),
          edit: '',
          archiver: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          return this.actionsLoadRegimeTva(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.regimesTva,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          archiver: 'colonneSelected',
          actif: 'colonneAction',
        },
        sortable: ['libelle', 'tauxTva', 'compteCentralisationClient', 'compteCentralisationFournisseur', 'cleComptable', 'actif'],
      };
    },
    columns() {
      return ['libelle', 'tauxTva', 'compteCentralisationClient', 'compteCentralisationFournisseur', 'cleComptable', 'actif', 'edit', 'archiver', 'delete'];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    ...RegimeTva.mapActions({
      actionsLoadRegimeTva: 'loadRegimeTva',
    }),
    finLoading() {
      this.loadingComponent.close();
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreRegimeTva.initializeFiltre();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs.tableRegimeTva.refresh();
    },
    goFirstPage() {
      this.$refs.tableRegimeTva.setPage(1);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    setRegimeTvaToUpdate(regimeTvaToEdit) {
      if (!regimeTvaToEdit) this.regimeTvaToEdit = genererRegimeTva();
      else this.regimeTvaToEdit = regimeTvaToEdit;
      this.popUpRegimeTva = true;
    },
    setProduitToArchive(regimeTva) {
      this.regimeTvaToArchive = regimeTva;
      this.popUpArchivageRegimeTva = true;
    },
    async archiverProduit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        await archiver({ id: this.regimeTvaToArchive.id, archiver: this.regimeTvaToArchive.actif });
        if (this.regimeTvaToArchive.actif) messageSucces(this.$t('listeRegimeTva.archivage.sucessArchivage'));
        else messageSucces(this.$t('listeRegimeTva.archivage.successDesarchivage'));
        this.recherche();
        this.regimeTvaToArchive = null;
        this.popUpArchivageRegimeTva = false;
        await this.loadParametreForce(PARAMETRES_KEYS.regimeTva);
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validationArchivage(e.response, this.messages);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    reinitialiser() {
      this.$refs.filtreRegimeTva.initializeFiltre();
      this.$refs.filtreRegimeTva.viderCritere();
      this.$refs.filtreRegimeTva.appliquerCritere();
      this.showFiltre = false;
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageParametrage.regimeTva.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
